import Vue from 'vue'
import Vuex from 'vuex'
// vuex-persistedstateをsimplestorage使うための記述
// import createPersistedState from '@/service'
import TextData from './text'
import setting from '@/setting'

import createPersistedState from 'vuex-persistedstate'
// applicanのhttpメソッドではなくaxiosを使う場合
import axios from 'axios'
console.log(axios)

Vue.use(Vuex)

const state = {
  transitionName: 'fade',
  // レスポンシブ対応用
  mediaType: '',
  navState: false,
  hogeApiTestData: null,
  lang: {
    key: 'JP',
    lang: '日本語（JP）',
    params: 'ja'
  },
  textData: TextData,
  museumList: [],
  // 四方の位置情報
  aroundLocation: null,
  // slider
  sliderFlg: false,
  searchMode: 0
}

const actions = {
  changeTransitionName ({ state, commit }, { name }) {
    commit('changeTransitionName', name)
  },
  setMediaType ({ state, commit }, { type }) {
    commit('setMediaType', type)
  },
  changeNavState ({ state, commit }) {
    commit('changeNavState')
  },
  // 言語
  setLang ({ state, commit }, { name }) {
    commit('setLang', name)
  },
  // 施設一覧
  setMuseumList ({state, commit}) {
    return new Promise((resolve, reject) => {
      axios.get(
        setting.apiURL + 'museum/?lang=' + state.lang.params,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      ).then((res) => {
        console.log(res)
        commit('setMuseumList', res)
        resolve(res)
      }).catch((err) => {
        console.log(err)
        reject(err)
      })
    })
  },
  // 四方の位置情報を設定
  setAroundLocation ({ state, commit }, { location }) {
    commit('setAroundLocation', location)
  },
  // slider表示
  setSliderFlg ({ state, commit }, mode) {
    commit('setSliderFlg', mode)
  },
  resetSliderFlg ({ state, commit }) {
    commit('resetSliderFlg')
  }
}

const mutations = {
  changeTransitionName (state, payload) {
    state.transitionName = payload
  },
  setMediaType (state, payload) {
    state.mediaType = payload
  },
  changeNavState (state, payload) {
    state.navState = !state.navState
  },
  // 言語
  setLang (state, payload) {
    state.lang = payload
  },
  // 施設一覧
  setMuseumList (state, payload) {
    state.museumList = payload.data
  },
  // 四方の位置情報を設定
  setAroundLocation (state, location) {
    state.aroundLocation = location
  },
  // slider
  setSliderFlg (state, payload) {
    state.searchMode = payload
    state.sliderFlg = true
  },
  resetSliderFlg (state) {
    state.searchMode = 0
    state.aroundLocation = null
    state.sliderFlg = false
  }
}

const getters = {
  transitionName: state => state.transitionName,
  mediaType: state => state.mediaType,
  navState: state => state.navState,
  lang: state => state.lang,
  textData: state => state.textData,
  museumList: state => state.museumList,
  aroundLocation: state => state.aroundLocation,
  sliderFlg: state => state.sliderFlg,
  searchMode: state => state.searchMode
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  plugins: [createPersistedState(
    {
      key: 'pocket_app',
      // 明示的にsimplestorage/localstorageに保存するものを記載する
      reducer: state => ({
        lang: state.lang
      })
    }
  )]
})



// WEBPACK FOOTER //
// ./src/store/index.js